import { gql, useLazyQuery, useMutation } from '@apollo/client';
import { capitalize } from 'lodash';

export const TALENT_SPECIALITY_PAYLOAD = gql`
    fragment TalentSpecialityPayload on TalentSpecialty {
        _id
        name
        groupName
    }
`;

export const getTalentSpecialtiesQuery = gql`
    query getTalentSpecialties {
        specialities: getTalentSpecialties {
            ...TalentSpecialityPayload
        }
    }
    ${TALENT_SPECIALITY_PAYLOAD}
`;

export const useGetSpecialties = () => {
    return useLazyQuery(getTalentSpecialtiesQuery, {
        fetchPolicy: 'cache-and-network',
    });
};

export const updateTalentSpecialtiesQuery = type => {
    return gql`
        mutation updateTalentSpecialties($specialties: [ID!]!) {
            updateTalentSpecialties${type}(specialties: $specialties) {
                _id
                specialties {
                    ...TalentSpecialityPayload
                }
            }
        }
        ${TALENT_SPECIALITY_PAYLOAD}
    `;
};

export const useUpdateTalentSpecialties = (type, options) => {
    return useMutation(updateTalentSpecialtiesQuery(capitalize(type)), options);
};

export const ADD_TALENT_SPECIALTY = gql`
    mutation addTalentSpecialty($name: String!, $order: Int!) {
        data: addTalentSpecialty(name: $name, order: $order) {
            _id
            name
            profession {
                _id
                name
            }
            status
            order
        }
    }
`;

export const ADD_TALENT_SPECIALTY_PRO = gql`
    mutation addTalentSpecialtyPro($name: String!, $order: Int) {
        data: addTalentSpecialtyPro(name: $name, order: $order) {
            _id
            name
            profession {
                _id
                name
            }
            status
            order
        }
    }
`;

export const DELETE_TALENT_SPECIALTY_PRO = gql`
    mutation deleteTalentSpecialtyPro($id: ID!) {
        deleteTalentSpecialtyPro(id: $id)
    }
`;
